
<div class="pre-header__wrapper">
    <div class="container">
        <div>
            <a class="pre-header__logo"
            title="Clic para abrir https://www.gov.co/ en una nueva pestaña" tabindex="1">
                <span
                class="sr-only">Enlace a Gov.co</span>
                <img fetchpriority="high" class="pre-header__gov-co"
                    src="https://back.haciendabogota.gov.co/sites/default/files/2021-09/Group%2035_1.svg"
                    alt="Logotipo de GOV.CO" title="Logotipo de GOV.CO" width="135"
                    height="27">
            </a>
        </div>
        <span class="pre-header__link-gov">ir a 
            <div class="normal">
                <a title="Clic para abrir https://www.gov.co/ En una nueva pestaña" tabindex="1" href="https://www.gov.co/" target="_blank"> GOV.CO</a>
            </div>
        </span>
    </div>
</div>

